import { is } from "./is";
import { show } from "./show";
import { showType } from "./show-type";
import { TypeKey, KindKey, CustomType } from "../symbols";

export const Type = (name, spec) => {
  const constructor = (...values) => {
    const specKeys = Object.keys(spec);
    const data = specKeys.reduce(
      (acc, key, i) => ((acc[key] = values[i]), acc),
      {}
    );

    const errors = specKeys.reduce((acc, key, i) => {
      const val = values[i];
      const T = spec[key];

      return is(val, T) ? acc : acc.concat({ key, type: T, val });
    }, []);

    if (errors.length) {
      throw new TypeError(`
Invalid types passed into the ${name}(${showType(spec)}) constructor:
${errors
        .map(
          ({ key, type, val }) =>
            `  * Field: ${key} - expected value of type ${showType(
              type
            )} but got: ${show(val)}`
        )
        .join("\n")}
`);
    }

    return { [TypeKey]: name, [KindKey]: CustomType, ...data };
  };
  constructor[KindKey] = CustomType;
  constructor[TypeKey] = name;

  return constructor;
};
